import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { EFProduct } from '../../../models/experience.model';
import { LocalizationService } from '../../../services/localization.service';

class EfCalendarData {
    date: Date
    products: Array<EFProduct>
    visibleProducts: Array<EFProduct>
}

@Component({
    selector: 'app-ef-calendar',
    templateUrl: './ef-calendar.component.html',
    styleUrls: ['./ef-calendar.component.scss'],
    standalone: false
})
export class EfCalendarComponent implements OnInit {

    @Input() productsData:Array<EFProduct>;
    @Input() dateInterval:{ from: string, to: string };
    @Input() vertical:boolean;
    @Input() full:boolean;

    @Output() showProduct = new EventEmitter<string>();

    isLoading = false;

    calendarData:Array<EfCalendarData> = [];
    visibleCalendarData:Array<EfCalendarData> = [];

    constructor(private localizationService:LocalizationService) { }

    @ViewChild('datesContainer') datesContainer:ElementRef;


    ngOnInit(): void {
    }

    viewMoreProducts(index:number) {
        let _day = this.calendarData[index]

        if(_day != null) {
            for(let i = 0; i < 3; i++) {
                if(_day.visibleProducts.length < _day.products.length) {
                    _day.visibleProducts.push(_day.products[_day.visibleProducts.length])
                }
            }
        }
    }

    viewMoreCalendar() {
        for(let i = 0; i < 3; i++) {
            if(this.visibleCalendarData.length < this.calendarData.length) {
                this.visibleCalendarData.push(this.calendarData[this.visibleCalendarData.length])
                this.viewMoreProducts(this.visibleCalendarData.length - 1)
            }
        }
    }

    ngOnChanges() {
        this.dateOffset = 0;

        this._loadData();
    }

    private _loadTimeout = null;

    private _loadData() {
        this.calendarData = [];
        this.visibleCalendarData = []
        this.isLoading = true;

        clearTimeout(this._loadTimeout)

        this._loadTimeout = setTimeout(() => {
            let _cDate = new Date(Date.now());
            let _cDateTo = new Date(_cDate);
    
            if(this.dateInterval != null) {
                _cDate = new Date(this.dateInterval.from);
                _cDateTo = new Date(this.dateInterval.to);
            }
            else {
                let _nextMondayDiff = ((1 - _cDate.getDay()) + 7) % 7;

                if(this.dateOffset < 2 || this.dateOffset < _nextMondayDiff) {
                    _cDate.setDate(_cDate.getDate() + this.dateOffset);
                    _cDateTo.setDate(_cDateTo.getDate() + this.dateOffset);
                }
                else {
                    let _weekDiff = this.dateOffset - _nextMondayDiff;

                    _cDate.setDate(_cDate.getDate() + _nextMondayDiff + _weekDiff * 7);
                    _cDateTo.setDate(_cDateTo.getDate() + _nextMondayDiff + (_weekDiff + 1) * 7 - 1);
                }
            }
    
            while(_cDate.getTime() <= _cDateTo.getTime()) {
                let _cCalendarData = {
                    date: new Date(_cDate),
                    products: [],
                    visibleProducts: []
                }
    
                for(let _cProduct of this.productsData) {
                    if(_cProduct.type == 'itinerary') {
                        _cCalendarData.products.push(_cProduct);
                    }
                    else if(_cProduct.availability != null) {
                        if(_cProduct.availability.isAvailableOn(_cDate.getFullYear(), _cDate.getMonth() + 1, _cDate.getDate(), true)) {
                            _cCalendarData.products.push(_cProduct);
                        }
                    }
                }
    
                if(_cCalendarData.products.length > 0) this.calendarData.push(_cCalendarData)
    
                _cDate.setDate(_cDate.getDate() + 1)
            }

            this.viewMoreCalendar();

            for(let i = 0; i < this.visibleCalendarData.length; i++) {
                this.viewMoreProducts(i);
            }

            this.isLoading = false;
    
            this._loadTimeout = setTimeout(() => {
                if(this.datesContainer != null) {
                    (this.datesContainer.nativeElement as HTMLElement).scrollTo({ top: 0, behavior: 'smooth' })
                }
            }, 100)
        }, 100)
    }

    getTranslatedProperty(product:EFProduct, prop:string) {
        if(product.translations != null && product.translations[this.localizationService.currentLanguage] != null && product.translations[this.localizationService.currentLanguage][prop] != null) {
            return product.translations[this.localizationService.currentLanguage][prop]
        }
        else if(product[prop] != null) {
            return product[prop]
        }
        else return ''
    }

    formatDate(date:Date) {
        return this.localizationService.format.date(date, true)
    }

    dateOffset = 0;

    canGoPrev() {
        return this.dateOffset > 0;
    }

    canGoNext() {
        return this.dateOffset < 9;
    }

    goPrev() {
        if(this.canGoPrev()) {
            this.dateOffset--
            this._loadData();
        }
    }

    goNext() {
        if(this.canGoNext()) {
            this.dateOffset++;
            this._loadData();
        }
    }

    getFormattedMonthOffset() {
        if(this.dateOffset == 0) {
            return this.localizationService.translate('experience-finder.general.today')
        }
        else if(this.dateOffset == 1) {
            return this.localizationService.translate('experience-finder.general.tomorrow')
        }
        else if(this.visibleCalendarData != null && this.visibleCalendarData.length > 0) {
            if(this.visibleCalendarData.length == 1) {
                return this.formatDate(this.visibleCalendarData[0].date)
            }
            else {
                return this.localizationService.translate('experience-finder.general.next-dates')
            }
        }
    }
}
